
import { Link } from "react-router-dom";
import StatusBadge from "./StatusBadge";

function ClientCard({ client, onDelete }) {
  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDelete(client);
  };

  return (
    <div className="cc-client-row">
      <Link to={`/client/${client._id}`} className="cc-client-main">
        <div className="cc-client-avatar">{(client.nombre || "?").slice(0,1).toUpperCase()}</div>
        <div>
          <strong className="cc-client-name">{client.nombre} {client.apellido || ""}</strong>
          <div className="cc-client-meta">{client.dni ? `DNI ${client.dni}` : "Sin DNI"} · {client.telefono || "Sin teléfono"}</div>
        </div>
      </Link>
      <div className="cc-client-stat">
        <span className="cc-list-label">Estado</span>
        <StatusBadge status={client.estado} />
      </div>
      <div className="cc-client-stat">
        <span className="cc-list-label">Créditos</span>
        <strong>{client.cantidadCreditos || 0}</strong>
      </div>
      <div className="cc-client-stat cc-client-debt">
        <span className="cc-list-label">Deuda</span>
        <strong>{new Intl.NumberFormat("es-AR",{style:"currency",currency:"ARS",maximumFractionDigits:0}).format(client.totalDeuda || 0)}</strong>
      </div>
      <button className="cc-icon-delete" type="button" onClick={handleDelete} aria-label="Eliminar cliente">×</button>
    </div>
  );
}
export default ClientCard;
